import { spanWrapText } from "./libs";
import { gsap } from 'gsap'

const setHeroAnim = () => {
  const hero = document.querySelector('.js-menu-hero');
  if (!hero) return false;

  const
    Kv = hero.querySelector('.js-menu-kv img'),
    Title = hero.querySelectorAll('.js-menu-title'),

    Logo = document.querySelector('.js-brand-logo'),
    Gn = document.querySelector('.js-gn-menu');

  spanWrapText(Title);
  const TitleChar = Title[0].querySelectorAll('.char');

  gsap.set(TitleChar, {
    display: 'inline-block',
  })

  gsap
    .timeline()
    .from(Kv,
      {
        scale: 1.05,
        opacity: 0,
        duration: 1.4,
        ease: 'quad.out',
      }
    )
    .from(Logo,
      {
        autoAlpha: 0,
        duration: 1,
        ease: 'quad.out',
      },
      '<0.1'
    )
    // .from(Gn,
    //   {
    //     autoAlpha: 0,
    //     y: -80,
    //     scaleY: 2,
    //     duration: 1,
    //     ease: 'expo.out',
    //   },
    //   '<0.2'
    // )
    .fromTo(TitleChar,
      {
        autoAlpha: 0,
      },
      {
        autoAlpha: 1,
        duration: 0.8,
        ease: 'sine.inOut',
        stagger: 0.02,
      },
      '<0.4'
    )
}

export default setHeroAnim;